export const initialState = () => ({
  onlineStatus: false,
  currentCoordinates: {
    longitude: null,
    latitude: null,
    accuracy: null
  }
})
